<template>
  <div class="specials">
      <button type="button" class="accessibility-btn" @click="eventEmitter('emitChangeBoolean', 'accessibility')">
        <a>
          <font-awesome-icon :icon="['fas', 'adjust']" />
        </a>
      </button>
    <button 
      v-for="(item, index) in switchers" 
      :key="index"
      type="button"
      class="accessibility-btn">
      <a 
        :href="item.url"
        :synchro="item.is_synchro"
        v-html="item.icon"
      />
      <div v-if="item.tooltip" class="tooltip" v-html="item.tooltip"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "fcwpSpecials",
  props: ["switchers"],
  methods: {
    eventEmitter(method, value) {
      this.$root.$emit(method, value);
    },
  }
};
</script>

<style scoped lang="scss">
.specials {
  button {
    display: block;
    text-transform: uppercase;
    background-color: rgb($primary-color);
  }
  button:hover a {
    color: rgb($secondary-color);
  }
  button:hover .tooltip {
    visibility: visible;
    opacity: 1;

  }
  .accessibility-btn {
    position: relative;

    // font-size: 1.2vw;
    border-radius: 7px 0px 0px 7px;
    width: 2.5vw;
    z-index: 99999;
    padding: 0.3vw 0.3vw 0.4vw 0.3vw;
    margin-bottom: 10px;
    font-size: 1em;
    width: 50px;

    a {
      color: rgb($quaternary-color);
    }

    .tooltip {
      position: absolute;
      width: 300px;
      max-width: 50vw;
      right: 70px;
      top: 0;
      text-transform: none;
      padding: 10px 10px 0 10px;
      visibility: hidden;
      opacity: 0;
      transition: visibility 0.5s, opacity 0.5s linear;
      -webkit-border-radius: 10px;
      -moz-border-radius: 10px;
      border-radius: 10px;
      font-size: 70%;
      background: rgba($quaternary-color, 0.6);
      border: 4px solid rgb($secondary-color);
    }
    .tooltip:after, .tooltip:before {
      left: 100%;
      top: 25px;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
    }

    .tooltip:before {
      border-color: rgba(245, 83, 83, 0);
      border-left-color: rgb($secondary-color);
      border-width: 10px;
      margin-top: -10px;
    }

  }

}



@media (max-width: 1199px) {
  .specials {
    .accessibility-btn {
      font-size: 1em;
      // top: 2vw;
      width: 50px;
      padding: 0 5px 6px 5px;
    }
  }
}
@media (max-width: 700px) {
  .specials {
    width: 31px;
    .accessibility-btn {
      top: 50px;
      width: 31px;
      height: 31px;
      padding: 0 2px 0 2px;
      font-size: 10pt;
    }
  }

}
</style>